"use strict";

const onScrollCallbacks = [];

$(() => {
  let timer;
  let wait = false;

  $(window).scroll(function () {
    if (wait) {
      return;
    }
    wait = true;

    timer = window.setTimeout(function () {
      window.clearTimeout(timer);
      onScrollCallbacks.forEach((callback, i) => {
        callback();
      });
      wait = false;
    }, 200);
  });

  const scrolledClassSetter = () => {
    if ($(document).scrollTop() > 16) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
      if ($('#columnToggles').length > 0) {
        $('#columnToggles').closest('body.luftwaffe').addClass("scrolled");
      }
    }

    if ($(document).scrollTop() > 100) {
      $(".scroll-to-top").addClass("visible");
    } else {
      $(".scroll-to-top").removeClass("visible");
    }
  }

  scrolledClassSetter();
  onScrollCallbacks.push(scrolledClassSetter);
});
